import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtm } from '../utils/utm';

/**
 * Captures UTM params on first page load and on every client-side
 * navigation, storing them in the first-party `om_utm` cookie +
 * localStorage. Last click wins. Renders nothing.
 *
 * Must live INSIDE <BrowserRouter> so `useLocation()` is available.
 */
export default function UtmCapture() {
  const { search, pathname } = useLocation();

  useEffect(() => {
    captureUtm(search, pathname);
  }, [search, pathname]);

  return null;
}
